export default __webpack_public_path__ + "static/thumbnail-video-7cc3d8a7ad625f62edd3fb76a56652a5.jpg";